import React from "react";

const svgIcons = {
    ActiveClientProjectsIcon: {
        viewBox: "0 0 13 14",
        content: (
            <path
                d="M4.39982 5.95968V10.6472M8.41767 5.95968V10.6472M7.74803 1.94182C7.74803 1.58662 7.60693 1.24597 7.35576 0.994807C7.1046 0.743642 6.76395 0.602539 6.40875 0.602539C6.05355 0.602539 5.71289 0.743642 5.46173 0.994807C5.21056 1.24597 5.06946 1.58662 5.06946 1.94182M11.2704 5.08647L12.1978 11.1133C12.2271 11.304 12.2149 11.4988 12.1619 11.6844C12.109 11.87 12.0165 12.0419 11.8909 12.1885C11.7653 12.335 11.6095 12.4526 11.4342 12.5333C11.2589 12.6141 11.0683 12.6559 10.8753 12.6561H1.94223C1.74913 12.6561 1.5583 12.6144 1.38284 12.5338C1.20737 12.4531 1.05142 12.3355 0.925675 12.189C0.799926 12.0424 0.707355 11.8704 0.654308 11.6847C0.601262 11.4991 0.588993 11.3041 0.618345 11.1133L1.5458 5.08647C1.59445 4.77012 1.75478 4.48166 1.99776 4.27332C2.24074 4.06499 2.55029 3.95055 2.87035 3.95075H9.94714C10.2671 3.95071 10.5765 4.06522 10.8193 4.27354C11.0622 4.48186 11.2217 4.77024 11.2704 5.08647Z"
                stroke="white"
                strokeWidth="1.20536"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        ),
    },
    ActivePromotionalProjectsIcon: {
        viewBox: "0 0 12 17",
        content: (
            <path
                d="M8.79027 0.068259C8.88858 0.125251 8.96465 0.213896 9.00607 0.319714C9.04748 0.425532 9.05179 0.542267 9.01828 0.650848L7.20924 6.52897H10.5471C10.6452 6.52893 10.7411 6.55762 10.8231 6.61149C10.9051 6.66536 10.9695 6.74206 11.0084 6.83211C11.0472 6.92217 11.0589 7.02164 11.0419 7.11824C11.0249 7.21485 10.98 7.30437 10.9127 7.37574L2.87699 15.9137C2.79923 15.9964 2.69577 16.0503 2.58346 16.0666C2.47114 16.083 2.3566 16.0608 2.25851 16.0037C2.16041 15.9466 2.08454 15.858 2.04327 15.7523C2.002 15.6465 1.99775 15.5299 2.03123 15.4215L3.84027 9.54237H0.502433C0.404341 9.54241 0.308386 9.51372 0.226412 9.45985C0.144437 9.40598 0.0800322 9.32928 0.0411474 9.23923C0.00226264 9.14917 -0.00939972 9.0497 0.00759994 8.95309C0.0245996 8.85649 0.069517 8.76697 0.136807 8.6956L8.17252 0.157656C8.25018 0.0750885 8.35349 0.0212185 8.46564 0.00480554C8.5778 -0.0116075 8.69221 0.0104017 8.79027 0.0672545V0.068259ZM1.6646 8.5379H4.52029C4.59889 8.53789 4.67639 8.55632 4.74657 8.59171C4.81674 8.62711 4.87763 8.67848 4.92434 8.7417C4.97104 8.80492 5.00225 8.87821 5.01547 8.95569C5.02868 9.03317 5.02353 9.11267 5.00042 9.18779L3.62632 13.6506L9.38391 7.53344H6.52922C6.45062 7.53345 6.37312 7.51502 6.30294 7.47962C6.23277 7.44423 6.17188 7.39286 6.12517 7.32964C6.07847 7.26642 6.04725 7.19313 6.03404 7.11565C6.02082 7.03817 6.02598 6.95867 6.04908 6.88355L7.42319 2.42071L1.6646 8.5379Z"
                fill="white"
            />
        ),
    },
    ClientProjectsInPDIcon: {
        viewBox: "0 0 12 12",
        content: (
            <path
                d="M7.63691 0.428223V5.57108L10.7141 9.48822C10.8639 9.67791 10.9573 9.906 10.9835 10.1463C11.0096 10.3867 10.9674 10.6295 10.8618 10.847C10.7562 11.0645 10.5915 11.2478 10.3864 11.3758C10.1814 11.5039 9.94438 11.5716 9.70262 11.5711H2.14262C1.90086 11.5716 1.66387 11.5039 1.45882 11.3758C1.25378 11.2478 1.089 11.0645 0.983399 10.847C0.877796 10.6295 0.835646 10.3867 0.861787 10.1463C0.887929 9.906 0.981302 9.67791 1.13119 9.48822L4.20834 5.57108V0.428223M2.92262 0.428223H8.92262"
                stroke="white"
                strokeWidth="1.7085"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        ),
    },
    PromotionalProjectsInPDIcon: {
        viewBox: "0 0 10 16",
        content: (
            <path
                d="M1.03333 3.00016H8.63333M6.83333 12.0002L9.16666 0.333496H0.5L2.83333 12.0002L1.5 15.6668H8.16666L6.83333 12.0002Z"
                stroke="white"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        ),
    },
    ProjectsNotStartedIcon: {
        viewBox: "0 0 16 13",
        content: (
            <path
                d="M0.571411 6.28558H2.47617L4.85713 0.571289L6.76189 11.9999L9.61903 3.42843L11.6143 9.14272L12.9524 6.28558H14.8571"
                stroke="white"
                strokeWidth="1.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        ),
    },
    ProjectsNotSelectedIcon: {
        viewBox: "0 0 17 17",
        content: (
            <>
                <path
                    d="M8.19046 15.8094C12.3983 15.8094 15.8095 12.3982 15.8095 8.19034C15.8095 3.98245 12.3983 0.571289 8.19046 0.571289C3.98257 0.571289 0.571411 3.98245 0.571411 8.19034C0.571411 12.3982 3.98257 15.8094 8.19046 15.8094Z"
                    stroke="white"
                    strokeWidth="1.14286"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.33337 5.33301L11.0477 11.0473M11.0477 5.33301L5.33337 11.0473"
                    stroke="white"
                    strokeWidth="1.14286"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </>
        ),
    },
    ProjectsInProgressIcon: {
        viewBox: "0 0 10 12",
        content: (
            <path
                d="M1.20936 0.658719C1.14836 0.622552 1.07887 0.603174 1.00796 0.602554C0.937041 0.601935 0.867227 0.620096 0.805603 0.655193C0.74398 0.69029 0.692744 0.741071 0.6571 0.80238C0.621456 0.863688 0.602674 0.933338 0.602661 1.00425V10.3083C0.602674 10.3792 0.621456 10.4488 0.6571 10.5101C0.692744 10.5715 0.74398 10.6222 0.805603 10.6573C0.867227 10.6924 0.937041 10.7106 1.00796 10.71C1.07887 10.7094 1.14836 10.69 1.20936 10.6538L9.05958 6.0018C9.11954 5.96622 9.1692 5.91566 9.2037 5.85508C9.2382 5.7945 9.25634 5.72598 9.25634 5.65626C9.25634 5.58655 9.2382 5.51803 9.2037 5.45745C9.1692 5.39687 9.11954 5.3463 9.05958 5.31073L1.20936 0.658719Z"
                stroke="white"
                strokeWidth="1.20536"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        ),
    },
    ProjectPausedIcon: {
        viewBox: "0 0 10 12",
        content: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 10V2C3 1.73478 2.89464 1.48043 2.70711 1.29289C2.51957 1.10536 2.26522 1 2 1C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V10C1 10.2652 1.10536 10.5196 1.29289 10.7071C1.48043 10.8946 1.73478 11 2 11C2.26522 11 2.51957 10.8946 2.70711 10.7071C2.89464 10.5196 3 10.2652 3 10ZM2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12C2.53043 12 3.03914 11.7893 3.41421 11.4142C3.78929 11.0391 4 10.5304 4 10V2C4 1.46957 3.78929 0.960859 3.41421 0.585786C3.03914 0.210714 2.53043 0 2 0ZM9 10V2C9 1.73478 8.89464 1.48043 8.70711 1.29289C8.51957 1.10536 8.26522 1 8 1C7.73478 1 7.48043 1.10536 7.29289 1.29289C7.10536 1.48043 7 1.73478 7 2V10C7 10.2652 7.10536 10.5196 7.29289 10.7071C7.48043 10.8946 7.73478 11 8 11C8.26522 11 8.51957 10.8946 8.70711 10.7071C8.89464 10.5196 9 10.2652 9 10ZM8 0C7.46957 0 6.96086 0.210714 6.58579 0.585786C6.21071 0.960859 6 1.46957 6 2V10C6 10.5304 6.21071 11.0391 6.58579 11.4142C6.96086 11.7893 7.46957 12 8 12C8.53043 12 9.03914 11.7893 9.41421 11.4142C9.78929 11.0391 10 10.5304 10 10V2C10 1.46957 9.78929 0.960859 9.41421 0.585786C9.03914 0.210714 8.53043 0 8 0Z"
                fill="white"
            />
        ),
    },
    TotalSensoryApprovalIcon: {
        viewBox: "0 0 13 14",
        content: (
            <path
                d="M4.20469 10.4887L6.45469 8.75437L8.70469 10.4887L7.86094 7.62937L9.97031 6.12937H7.34531L6.45469 3.22312L5.56406 6.12937H2.93906L5.04844 7.62937L4.20469 10.4887ZM2.41406 13.0162L3.92719 8.01937L0 5.19187H4.89L6.45469 0L8.02031 5.19187H12.9094L8.98219 8.01937L10.4953 13.0162L6.45469 9.945L2.41406 13.0162Z"
                fill="white"
            />
        ),
    },
    TotalBDApprovalIcon: {
        viewBox: "0 0 16 16",
        content: (
            <path
                d="M4.26666 7.99987L7.46666 10.6665L11.7333 5.3332M7.99999 15.4665C7.01946 15.4665 6.04852 15.2734 5.14262 14.8982C4.23672 14.5229 3.41361 13.9729 2.72026 13.2796C2.02692 12.5863 1.47693 11.7631 1.10169 10.8572C0.726456 9.95134 0.533325 8.98041 0.533325 7.99987C0.533325 7.01933 0.726456 6.0484 1.10169 5.1425C1.47693 4.2366 2.02692 3.41348 2.72026 2.72014C3.41361 2.0268 4.23672 1.4768 5.14262 1.10157C6.04852 0.726334 7.01946 0.533203 7.99999 0.533203C9.98028 0.533203 11.8795 1.31987 13.2797 2.72014C14.68 4.12041 15.4667 6.01959 15.4667 7.99987C15.4667 9.98015 14.68 11.8793 13.2797 13.2796C11.8795 14.6799 9.98028 15.4665 7.99999 15.4665Z"
                stroke="white"
                strokeWidth="1.6"
            />
        ),
    },
    WaitingForPromotionIcon: {
        viewBox: "0 0 16 16",
        content: (
            <>
                <circle cx="8" cy="8" r="6.4" stroke="white" strokeWidth="1.2" />
                <path d="M8 4.9V8.05L10.4 9.75" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </>
        ),
    },
    AvgDevTimeIcon: {
        viewBox: "0 0 16 16",
        content: (
            <>
                <circle cx="8" cy="8" r="6.4" stroke="white" strokeWidth="1.2" />
                <path d="M8 4.9V8.05L10.4 9.75" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </>
        ),
    },
    TotalProductionIcon: {
        viewBox: "0 0 14 17",
        content: (
            <path
                d="M6.75 0.00124991L0 3.89687V12.5889L7 16.5889L13.5 12.5889V3.89875L6.75 0V0.00124991ZM6.75 2.50125L10.7044 4.7825L6.75 7.06625L2.79625 4.78375L6.75 2.50125ZM12.8352 11.3932L10.7044 12.5955L8.5 14.0887L7.5 14.5887H7H6.5L5.5 14.0887L2.79625 12.5955L0.706563 11.3932C0.706563 10.7861 0.696641 4.62096 0.67525 4.54097C0.653859 4.46097 0.665123 4.37575 0.706563 4.30406C0.748003 4.23237 0.816225 4.18008 0.896221 4.15869C0.976217 4.1373 0.67525 4.54097 1.13313 4.19L6.75 7.5874L12.3694 4.19C12.405 4.16951 12.4442 4.15623 12.4849 4.15092C12.5256 4.1456 12.567 4.14837 12.6066 4.15905C12.6463 4.16973 12.6834 4.18811 12.716 4.21316C12.7485 4.2382 12.7758 4.26941 12.7962 4.305C12.8167 4.34061 12.83 4.37991 12.8352 4.42065C12.8405 4.46139 12.8377 4.50276 12.8269 4.54241C12.8162 4.58206 12.8603 7.03374 12.8352 7.06625C12.8588 8.94455 12.8352 10.1994 12.8352 11.3932Z"
                fill="white"
            />
        ),
    },
    TotalSensoryTastedIcon: {
        viewBox: "0 0 13 17",
        content: (
            <>
                <path
                    d="M3.93331 2.2666H2.26664C1.82461 2.2666 1.40069 2.4422 1.08813 2.75476C0.77557 3.06732 0.599976 3.49124 0.599976 3.93327V13.9333C0.599976 14.3753 0.77557 14.7992 1.08813 15.1118C1.40069 15.4243 1.82461 15.5999 2.26664 15.5999H10.6C11.042 15.5999 11.4659 15.4243 11.7785 15.1118C12.091 14.7992 12.2666 14.3753 12.2666 13.9333V3.93327C12.2666 3.49124 12.091 3.06732 11.7785 2.75476C11.4659 2.4422 11.042 2.2666 10.6 2.2666H8.93331"
                    stroke="white"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.93335 9.76628H3.94168M3.93335 12.2663H3.94168M6.43335 11.4329L7.26668 12.2663L9.76668 9.76628M3.93335 2.26628C3.93335 1.82425 4.10894 1.40033 4.42151 1.08776C4.73407 0.775204 5.15799 0.599609 5.60002 0.599609H7.26668C7.70871 0.599609 8.13263 0.775204 8.44519 1.08776C8.75775 1.40033 8.93335 1.82425 8.93335 2.26628C8.93335 2.7083 8.75775 3.13223 8.44519 3.44479C8.13263 3.75735 7.70871 3.93294 7.26668 3.93294H5.60002C5.15799 3.93294 4.73407 3.75735 4.42151 3.44479C4.10894 3.13223 3.93335 2.7083 3.93335 2.26628Z"
                    stroke="white"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </>
        ),
    },
    TotalProductApprovalsIcon: {
        viewBox: "0 0 16 16",
        content: (
            <path
                d="M4.26666 7.99987L7.46666 10.6665L11.7333 5.3332M7.99999 15.4665C7.01946 15.4665 6.04852 15.2734 5.14262 14.8982C4.23672 14.5229 3.41361 13.9729 2.72026 13.2796C2.02692 12.5863 1.47693 11.7631 1.10169 10.8572C0.726456 9.95134 0.533325 8.98041 0.533325 7.99987C0.533325 7.01933 0.726456 6.0484 1.10169 5.1425C1.47693 4.2366 2.02692 3.41348 2.72026 2.72014C3.41361 2.0268 4.23672 1.4768 5.14262 1.10157C6.04852 0.726334 7.01946 0.533203 7.99999 0.533203C9.98028 0.533203 11.8795 1.31987 13.2797 2.72014C14.68 4.12041 15.4667 6.01959 15.4667 7.99987C15.4667 9.98015 14.68 11.8793 13.2797 13.2796C11.8795 14.6799 9.98028 15.4665 7.99999 15.4665Z"
                stroke="white"
                strokeWidth="1.6"
            />
        ),
    },
    TotalProjectsInReworkIcon: {
        viewBox: "0 0 16 14",
        content: (
            <path
                d="M7.646 12.75C7.646 12.9489 7.56698 13.1397 7.42633 13.2803C7.28568 13.421 7.09491 13.5 6.896 13.5C3.104 13.5 0 10.495 0 6.75C0 3.005 3.104 0 6.896 0C10.001 0 12.645 2.015 13.501 4.801L14.104 3.781C14.2052 3.60967 14.3703 3.48555 14.563 3.43595C14.7557 3.38634 14.9602 3.41532 15.1315 3.5165C15.3028 3.61768 15.4269 3.78278 15.4766 3.97547C15.5262 4.16816 15.4972 4.37267 15.396 4.544L13.766 7.299C13.6662 7.468 13.5041 7.59115 13.3145 7.642C13.125 7.69285 12.923 7.66736 12.752 7.571L9.93 5.98C9.84418 5.93161 9.76873 5.86679 9.70797 5.78924C9.6472 5.71169 9.6023 5.62293 9.57584 5.52803C9.54937 5.43312 9.54186 5.33394 9.55373 5.23613C9.56559 5.13833 9.59661 5.04382 9.645 4.958C9.69339 4.87218 9.75821 4.79673 9.83576 4.73597C9.91331 4.6752 10.0021 4.6303 10.097 4.60384C10.1919 4.57737 10.2911 4.56986 10.3889 4.58173C10.4867 4.59359 10.5812 4.62461 10.667 4.673L12.139 5.503C11.565 3.215 9.448 1.5 6.897 1.5C3.899 1.5 1.5 3.867 1.5 6.75C1.5 9.633 3.899 12 6.896 12C7.09491 12 7.28568 12.079 7.42633 12.2197C7.56698 12.3603 7.646 12.5511 7.646 12.75Z"
                fill="white"
            />
        ),
    },
    SamplesForClientsIcon: {
        viewBox: "0 0 17 17",
        content: (
            <>
                <g clipPath="url(#clip0_samples_for_clients)">
                    <path
                        d="M12.6186 5.27323C12.5266 6.54984 11.5796 7.53327 10.5469 7.53327C9.51418 7.53327 8.56558 6.55015 8.47518 5.27323C8.38101 3.94514 9.30292 3.01318 10.5469 3.01318C11.7909 3.01318 12.7128 3.96931 12.6186 5.27323Z"
                        stroke="white"
                        strokeWidth="1.00446"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M10.5469 9.54199C8.50123 9.54199 6.53405 10.5581 6.04123 12.5369C5.97594 12.7987 6.14011 13.0576 6.40912 13.0576H14.685C14.954 13.0576 15.1172 12.7987 15.0528 12.5369C14.56 10.5264 12.5929 9.54199 10.5469 9.54199Z"
                        stroke="white"
                        strokeWidth="1.00446"
                        strokeMiterlimit="10"
                    />
                    <path
                        d="M6.27793 5.83677C6.20448 6.85631 5.4392 7.65925 4.61428 7.65925C3.78937 7.65925 3.02283 6.85662 2.95064 5.83677C2.87562 4.77612 3.62049 4.01807 4.61428 4.01807C5.60807 4.01807 6.35295 4.79558 6.27793 5.83677Z"
                        stroke="white"
                        strokeWidth="1.00446"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.46623 9.6055C5.89965 9.34591 5.27563 9.24609 4.61425 9.24609C2.982 9.24609 1.40938 10.0575 1.01544 11.638C0.963651 11.847 1.09486 12.0539 1.30956 12.0539H4.83398"
                        stroke="white"
                        strokeWidth="1.00446"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_samples_for_clients">
                        <rect width="16.0714" height="16.0714" fill="white" />
                    </clipPath>
                </defs>
            </>
        ),
    },
    ApprovedCommercialIcon: {
        viewBox: "0 0 9 15",
        content: (
            <path
                d="M7.99357 8.54911C7.78658 8.18128 7.5062 7.85991 7.16983 7.60495C6.83347 7.34999 6.44829 7.16687 6.03821 7.06696C5.65354 6.95155 5.26313 6.85619 4.86857 6.78125V2.73214C5.653 2.81628 6.40137 3.10578 7.03821 3.57143C7.08218 3.61041 7.1334 3.64036 7.18894 3.65955C7.24448 3.67874 7.30326 3.68681 7.36192 3.68328C7.42058 3.67976 7.47797 3.66472 7.53081 3.63901C7.58366 3.61331 7.63092 3.57745 7.66991 3.53348C7.7089 3.48951 7.73884 3.43829 7.75803 3.38275C7.77722 3.32721 7.78529 3.26843 7.78177 3.20977C7.77824 3.15112 7.7632 3.09373 7.7375 3.04088C7.71179 2.98804 7.67593 2.94077 7.63196 2.90179C6.83298 2.28643 5.87354 1.91444 4.86857 1.83036V0.446429C4.86857 0.328028 4.82154 0.214477 4.73781 0.130756C4.65409 0.0470343 4.54054 0 4.42214 0C4.30374 0 4.19019 0.0470343 4.10647 0.130756C4.02275 0.214477 3.97571 0.328028 3.97571 0.446429V1.78571C2.01143 1.83036 0.926605 2.80804 0.596248 3.65179C0.375862 4.19511 0.354925 4.79891 0.537145 5.35619C0.719366 5.91348 1.09298 6.38827 1.59178 6.69643C2.31785 7.13903 3.13111 7.41925 3.97571 7.51786V11.6071C2.81023 11.5485 1.69374 11.12 0.788212 10.3839C0.747801 10.3358 0.697696 10.2968 0.641172 10.2694C0.584648 10.242 0.522977 10.2268 0.46019 10.2249C0.397404 10.223 0.334916 10.2343 0.276811 10.2582C0.218705 10.282 0.166291 10.3179 0.122993 10.3634C0.0796951 10.4089 0.0464887 10.4631 0.0255448 10.5223C0.00460088 10.5815 -0.0036093 10.6445 0.00145088 10.7071C0.00651105 10.7697 0.024728 10.8305 0.0549103 10.8856C0.0850926 10.9407 0.126561 10.9888 0.176605 11.0268C1.24461 11.9255 2.58103 12.4437 3.97571 12.5V13.8393C3.97571 13.9577 4.02275 14.0712 4.10647 14.155C4.19019 14.2387 4.30374 14.2857 4.42214 14.2857C4.54054 14.2857 4.65409 14.2387 4.73781 14.155C4.82154 14.0712 4.86857 13.9577 4.86857 13.8393V12.5C6.1275 12.4152 7.57839 12.0134 8.1275 10.375C8.22684 10.0769 8.26616 9.76205 8.24317 9.44866C8.22019 9.13527 8.13535 8.82953 7.99357 8.54911ZM2.09625 5.94643C1.77027 5.75238 1.52419 5.44842 1.40226 5.08918C1.28033 4.72994 1.29055 4.33899 1.43107 3.98661C1.48018 3.85268 1.98018 2.73214 3.97571 2.67857V6.60714C3.30975 6.52145 2.66934 6.29631 2.09625 5.94643ZM7.27928 10.0714C6.95786 11.0268 6.24357 11.4866 4.86857 11.5893V7.69196C5.15428 7.75446 5.44893 7.82589 5.76143 7.91964C6.05663 7.98669 6.33511 8.11308 6.57993 8.29113C6.82475 8.46918 7.0308 8.69517 7.18553 8.95536C7.36063 9.30106 7.39425 9.70136 7.27928 10.0714Z"
                fill="white"
            />
        ),
    },
};

const createIcon = (iconData) => {
    const IconComponent = ({ className }) => (
        <svg className={className} viewBox={iconData.viewBox} xmlns="http://www.w3.org/2000/svg" fill="none">
            {iconData.content}
        </svg>
    );

    return IconComponent;
};

export const ActiveClientProjectsIcon = createIcon(svgIcons.ActiveClientProjectsIcon);
export const ActivePromotionalProjectsIcon = createIcon(svgIcons.ActivePromotionalProjectsIcon);
export const ClientProjectsInPDIcon = createIcon(svgIcons.ClientProjectsInPDIcon);
export const PromotionalProjectsInPDIcon = createIcon(svgIcons.PromotionalProjectsInPDIcon);
export const ProjectsNotStartedIcon = createIcon(svgIcons.ProjectsNotStartedIcon);
export const ProjectsNotSelectedIcon = createIcon(svgIcons.ProjectsNotSelectedIcon);
export const ProjectsInProgressIcon = createIcon(svgIcons.ProjectsInProgressIcon);
export const ProjectPausedIcon = createIcon(svgIcons.ProjectPausedIcon);
export const TotalSensoryApprovalIcon = createIcon(svgIcons.TotalSensoryApprovalIcon);
export const TotalBDApprovalIcon = createIcon(svgIcons.TotalBDApprovalIcon);
export const WaitingForPromotionIcon = createIcon(svgIcons.WaitingForPromotionIcon);
export const AvgDevTimeIcon = createIcon(svgIcons.AvgDevTimeIcon);
export const TotalProductionIcon = createIcon(svgIcons.TotalProductionIcon);
export const TotalSensoryTastedIcon = createIcon(svgIcons.TotalSensoryTastedIcon);
export const TotalProductApprovalsIcon = createIcon(svgIcons.TotalProductApprovalsIcon);
export const TotalProjectsInReworkIcon = createIcon(svgIcons.TotalProjectsInReworkIcon);
export const SamplesForClientsIcon = createIcon(svgIcons.SamplesForClientsIcon);
export const ApprovedCommercialIcon = createIcon(svgIcons.ApprovedCommercialIcon);
